import { render, staticRenderFns } from "./AddMonitors.vue?vue&type=template&id=21cec9b2&scoped=true"
import script from "./AddMonitors.vue?vue&type=script&lang=js"
export * from "./AddMonitors.vue?vue&type=script&lang=js"
import style0 from "./AddMonitors.styl?vue&type=style&index=0&id=21cec9b2&prod&scoped=true&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cec9b2",
  null
  
)

export default component.exports